import { titleCase } from 'utils/common';
import moment from 'moment';
import { PLACEHOLDER_TEXT } from 'utils/constants';
import { BREAKDOWN_EVENT, VENDOR_SETTLEMENT_STATUS_TYPES } from './constants';

export const getVenodorSettlementStatusTitle = status => {
  if (
    status === VENDOR_SETTLEMENT_STATUS_TYPES.PENDING ||
    status === VENDOR_SETTLEMENT_STATUS_TYPES.CREATED
  ) {
    return 'In Progress';
  }
  return titleCase(status);
};

export const formatDateToDateTimeFormat = (dateString, format) => {
  if (!dateString || !format) {
    return PLACEHOLDER_TEXT;
  }
  return moment(dateString).format(format);
};
export const sortSettlementComponentsList = settlementComponentsList => {
  if (!settlementComponentsList?.length) {
    return [];
  }
  const otherAdjustmentComponentType = 'OTHER_ADJUSTMENT';

  const [otherAdjustmentComponent] = settlementComponentsList.filter(
    settlementComponent =>
      settlementComponent.event === otherAdjustmentComponentType,
  );
  if (!otherAdjustmentComponent) {
    return settlementComponentsList;
  }

  const processedSettlementComponents = settlementComponentsList.filter(
    settlementComponent =>
      settlementComponent.event !== otherAdjustmentComponentType,
  );
  processedSettlementComponents.push(otherAdjustmentComponent);
  return processedSettlementComponents;
};

export const getSmartReconEventLabel = event =>
  BREAKDOWN_EVENT[event] || titleCase(event);
